import React, { useMemo, useState } from "react";

import Box from "veneer/Box";
import { PageSize } from "veneer/DataTable";
import Tabs, { Tab, TabRow, TabsProvider } from "veneer/Tabs";

import IncidentsTable from "cortex/ui/src/fleet/view/incidents/IncidentsTable";
import { useFeatureFlag } from "cortex/ui/src/hooks";
import { Incident } from "cortex/ui/src/zeus/view/incidents/model";

interface DeviceIncidentsProps {
  sizePerPage?: PageSize;
  storesLoaded: boolean;
  tableData: ReadonlyArray<Incident>;
}

export default function DeviceIncidents({
  sizePerPage = 10,
  storesLoaded,
  tableData,
}: DeviceIncidentsProps) {
  const isGroupedTriggeredAlertsEnabled = useFeatureFlag(
    "is-grouped-triggered-alerts",
  );
  const [activeTab, setActiveTab] = useState("unresolved");

  const filteredTableData = useMemo(() => {
    return (tableData || []).filter((incident) => {
      const isResolved = !!incident?.resolved;
      return activeTab === "resolved" ? isResolved : !isResolved;
    });
  }, [activeTab, tableData]);

  return (
    <TabsProvider>
      <Box mb={1} px={1}>
        <TabRow />
      </Box>
      <Tabs>
        <Tab
          defaultSelected
          label={isGroupedTriggeredAlertsEnabled ? "Open" : "Unresolved"}
          onClick={() => setActiveTab("unresolved")}
        >
          <IncidentsTable
            grouped={false}
            hiddenColumns={["device_name"]}
            incidents={filteredTableData}
            sizePerPage={sizePerPage}
            storesLoaded={storesLoaded}
            type="unresolved"
          />
        </Tab>
        <Tab label="Resolved" onClick={() => setActiveTab("resolved")}>
          <IncidentsTable
            grouped={false}
            hiddenColumns={["device_name"]}
            incidents={filteredTableData}
            sizePerPage={sizePerPage}
            storesLoaded={storesLoaded}
            type="resolved"
          />
        </Tab>
      </Tabs>
    </TabsProvider>
  );
}
